// frontend/src/components/common/RequerimientoEstadoBadge.jsx
// Badge de estado de un requerimiento de compra. Definición única de etiquetas y
// colores: la usan la lista de Requerimientos del módulo Almacén y el informe de
// Requerimientos, para que el mismo pedido se vea igual en los dos lugares.
import React from 'react';
import styled from 'styled-components';

export const REQ_ESTADO_ETIQUETA = {
  borrador: 'Borrador',
  pendiente: 'Pendiente',
  ingreso_parcial: 'Ingreso parcial',
  recibido: 'Recibido',
  completado: 'Cerrado',
  entrega_atrasada: 'Entrega atrasada',
  entrega_parcial_atrasada: 'Entrega parcial atrasada',
};

export const REQ_ESTADO_BADGE_VARIANTES = {
  borrador: { bg: 'bgSecundario', txt: 'txtSecundario', border: 'borderDefault' },
  pendiente: { bg: 'infoBg', txt: 'infoTxt', border: 'infoBorder' },
  ingreso_parcial: { bg: 'warningBg', txt: 'warningTxt', border: 'warningBorder' },
  recibido: { bg: 'successBg', txt: 'successTxt', border: 'successBorder' },
  completado: { bg: 'successBg', txt: 'successTxt', border: 'successBorder' },
  entrega_atrasada: { bg: 'dangerBg', txt: 'dangerTxt', border: 'dangerBorder' },
  entrega_parcial_atrasada: { bg: 'naranjaBg', txt: 'naranjaTxt', border: 'naranjaBorder' },
};

// Color pleno por estado, para gráficos (el badge usa la variante pastel de arriba).
export const REQ_ESTADO_COLOR = {
  borrador: 'txtSecundario',
  pendiente: 'info',
  ingreso_parcial: 'warning',
  recibido: 'success',
  completado: 'success',
  entrega_atrasada: 'danger',
  entrega_parcial_atrasada: 'naranja',
};

const Badge = styled.span`
  display: inline-block;
  white-space: nowrap;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  background: ${({ theme, $estado }) => theme.colors[REQ_ESTADO_BADGE_VARIANTES[$estado]?.bg] || theme.colors.bgSecundario};
  color: ${({ theme, $estado }) => theme.colors[REQ_ESTADO_BADGE_VARIANTES[$estado]?.txt] || theme.colors.txtPrincipal};
  border: 1px solid ${({ theme, $estado }) => theme.colors[REQ_ESTADO_BADGE_VARIANTES[$estado]?.border] || theme.colors.borderDefault};
`;

const RequerimientoEstadoBadge = ({ estado, children }) => (
  <Badge $estado={estado}>{children || REQ_ESTADO_ETIQUETA[estado] || estado}</Badge>
);

export default RequerimientoEstadoBadge;
